import { useState, FormEvent } from 'react';
import { useAuth } from '../hooks/useAuth';
import { Button } from '../components/common/Button';
import { TrademarkNotice } from '../components/common/TrademarkNotice';

export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login, loading, error } = useAuth();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      await login(email, password);
    } catch {
      // Error is handled by useAuth
    }
  };

  return (
    <div className='min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-brand-50 to-brand-100 px-4'>
      <div className='bg-white p-8 rounded-xl shadow-lg w-full max-w-md'>
        <div className='text-center mb-8'>
          <h1 className='text-2xl font-bold text-gray-900'>
            Watch Keeper® Admin
          </h1>
          <p className='text-gray-500 mt-2'>Sign in to manage watch data</p>
        </div>

        <form
          onSubmit={handleSubmit}
          className='space-y-6'
        >
          <div>
            <label
              htmlFor='email'
              className='block text-sm font-medium text-gray-700 mb-1'
            >
              Email
            </label>
            <input
              id='email'
              type='email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className='w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-brand-500 focus:border-brand-500'
              placeholder='admin@example.com'
            />
          </div>

          <div>
            <label
              htmlFor='password'
              className='block text-sm font-medium text-gray-700 mb-1'
            >
              Password
            </label>
            <input
              id='password'
              type='password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className='w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-brand-500 focus:border-brand-500'
              placeholder='********'
            />
          </div>

          {error && (
            <div className='bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm'>
              {error}
            </div>
          )}

          <Button
            type='submit'
            className='w-full'
            loading={loading}
            disabled={loading}
          >
            Sign In
          </Button>
        </form>
      </div>
      <TrademarkNotice className='mt-6 max-w-md' />
    </div>
  );
}
